var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app-bar",
    { staticClass: "asta-nav", attrs: { app: "", dark: "" } },
    [
      _c(
        "v-btn",
        {
          staticClass: "asta-nav-user navy darken-1 white--text",
          attrs: { rounded: "", depressed: "" },
          on: { click: _vm.toggleDrawer },
        },
        [
          _c(
            "v-avatar",
            { staticClass: "asta-nav-user-avatar", attrs: { size: "28" } },
            [
              _vm.user_pic
                ? _c("v-img", { attrs: { contain: "", src: _vm.user_pic } })
                : _c("v-icon", { attrs: { small: "" } }, [
                    _vm._v("account_circle"),
                  ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("span", { staticClass: "asta-nav-user-name" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.user_displayName || _vm.user_uid) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "v-icon",
            { staticClass: "asta-nav-user-chevron", attrs: { small: "" } },
            [_vm._v("expand_more")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "asta-nav-center d-flex flex-column align-center" },
        [
          _c(
            "div",
            { staticClass: "d-flex justify-center align-center" },
            [
              !_vm.mode_assegna
                ? _c("semaforo", { attrs: { mode: "bar" } })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("secondary-toolbar", { staticClass: "asta-nav-secondary" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }